import { createContext, useContext } from 'react';

export const ImpersonationContext = createContext({
  effectiveUserId: null,
  isImpersonating: false,
});

export function useEffectiveUser() {
  return useContext(ImpersonationContext);
}
